import(/* webpackMode: "eager" */ "/home/runner/work/customer-mono/customer-mono/companion-auth/src/app/global-error.tsx");
